// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-txUT","title":"styles_title__XNpcs"};